import { HttpClient } from '../HttpClient';
/**
 * * Get Ecosystem URL
 */
export const GetEcosystemUrl = async () => {
  try {
    const { data } = await HttpClient.get('/api/Ecosystem/Url');

    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
